import { environment } from '../../environments/environment';

import { CronogramaFinanceiro } from '../core/model';

import { Headers, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';

import { LazyLoadEvent } from 'primeng/api';

import 'rxjs/add/operator/toPromise';
import moment from 'moment';

export class CronogramaFinanceiroFiltro {
  entidadeConcedente: string;
  pagina = 0;
  itensPorPagina = 2;
}

@Injectable()
export class CronogramaFinanceiroService {

  url: string;

  constructor(private http: AuthHttp) {
    this.url = `${environment.apiUrl}/cronograma-financeiro`;
  }

  pesquisar(filtro: CronogramaFinanceiroFiltro): Promise<any> {
    const params = new URLSearchParams();

    params.set('page', filtro.pagina.toString());
    params.set('size', filtro.itensPorPagina.toString());

    if (filtro.entidadeConcedente) {
      params.set('entidadeConcedente', filtro.entidadeConcedente);
    }

    return this.http.get(`${this.url}`, { search: params })
      .toPromise()
      .then(response => {
        const responseJson = response.json();
        const dados = responseJson.content;

        const resultado = {
          dados,
          total: responseJson.totalElements
        };
        // //console.log(resultado)
        return resultado;

      })
  }

  listarTodos(): Promise<any> {
    return this.http.get(this.url)
      .toPromise()
      .then(response => response.json().content);
  }

  excluir(codigo: number): Promise<void> {
    return this.http.delete(`${this.url}/${codigo}`)
      .toPromise()
      .then(() => null);
  }

  adicionar(entidade: CronogramaFinanceiro): Promise<CronogramaFinanceiro> {
    return this.http.post(this.url, JSON.stringify(entidade))
      .toPromise()
      .then(response => response.json());
  }

  atualizar(entidade: CronogramaFinanceiro): Promise<CronogramaFinanceiro> {
    return this.http.put(`${this.url}/${entidade.id}`,
      JSON.stringify(entidade))
      .toPromise()
      .then(response => response.json() as CronogramaFinanceiro);
  }

  buscarPorCodigo(codigo: number): Promise<CronogramaFinanceiro> {
    return this.http.get(`${this.url}/${codigo}`)
      .toPromise()
      .then(response => {
        const entidade = response.json() as CronogramaFinanceiro;
        return entidade;
      });
  }

}
